/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Pipe, PipeTransform } from '@angular/core';
import { InterpolationData } from '@common';
import { ContentService } from '../../services/content/content.service';

@Pipe({
  name: 'content',
  standalone: true,
})
export class ContentPipe implements PipeTransform {
  private readonly contentService = inject(ContentService);

  transform(
    contentId: string,
    interpolationData?: InterpolationData,
  ): string | any {
    return this.contentService.getContent(contentId, interpolationData);
  }
}
